import React from 'react';
import { Card, Row } from 'antd';
import moment from 'moment';
import Text from 'antd/lib/typography/Text';
import Form, { FormInstance } from 'antd/lib/form';

import FormInput from 'components/FormInput';
import Value from 'components/Value';
import { toCurrency } from 'utils/utils';
import { shouldUpdateCompare } from '../../../../utils/utils2';
import NettingList from 'pages/Payment/PAYNetting/NettingList';
import { isNil } from 'lodash';

type TabSupplierInvoiceNettingProps = {
  form: FormInstance;
  siid: Number;
  refetchNetting?: Boolean;
  isActive?: boolean;
};

const TabSupplierInvoiceNetting = ({form,siid,refetchNetting,isActive}: TabSupplierInvoiceNettingProps) => (
  <Card>
    <Row>
      {/* <Form.Item noStyle shouldUpdate={shouldUpdateCompare('sirejected')}>
        {({ getFieldValue }) => (
          <FormInput name="sirejected" col xl={3} lg={4} md={12} sm={24}>
            <a style={{ color: 'blue' }}>
              {getFieldValue('sirejected') === true ? 'Yes' : 'No'}
            </a>
          </FormInput>
        )}
      </Form.Item> */}
      <Form.Item noStyle shouldUpdate={shouldUpdateCompare('statuslabel')}>
        {({ getFieldValue }) => (
          <FormInput
            name="statuslabel"
            style={{ color: 'green' }}
            col
            xl={6}
            lg={4}
            md={12}
            sm={24}
          >
            <Text>
              {getFieldValue('statuslabel')}{' '}
              {!isNil(getFieldValue('sistatusdate' as any)) &&
                moment(getFieldValue('sistatusdate' as any)).format(
                  'YYYY-MM-DD'
                )}
            </Text>
          </FormInput>
        )}
      </Form.Item>
      <FormInput
        name="sigrosstotal"
        style={{ color: 'blue' }}
        col
        xl={3}
        lg={4}
        md={12}
        sm={24}
      >
        <Value
          formatter={(val) =>
            toCurrency(val, form.getFieldValue('currcode'))
          }
        />
      </FormInput>
      <FormInput
        name="sidueamount"
        style={{ color: 'red' }}
        col
        xl={3}
        lg={4}
        md={12}
        sm={24}
      >
        <Value
          formatter={(val) =>
            toCurrency(val, form.getFieldValue('currcode'))
          }
        />
      </FormInput>
    </Row>
    <NettingList
      refetchNetting={refetchNetting}
      hideExtraAction
      hideFilters
      objectid={Number(siid)}
      objecttype="SINVOICE"
      isActive={isActive}
    />
  </Card>
);

export default TabSupplierInvoiceNetting;
